import axios from "axios";

const BASE_URL_PROD = process.env.REACT_APP_API_URL_PROD;
const BASE_URL_DEV = process.env.REACT_APP_API_URL_DEV;

export const postData = async (data, url) => {
  try {
    const res = await axios.post(
      `${
        process.env.NODE_ENV === "production" ? BASE_URL_PROD : BASE_URL_DEV
      }${url}`,
      data
    );
    return res;
  } catch (error) {
    console.log(error.response);
    return error.response;
  }
};
